<template>
    <div class="inviteregis-container">
        <div class="form-container">
            <van-field
                v-model="form.username"
                placeholder="请输入手机号"
                type="tel"
            ></van-field>
            <van-field v-model="code" placeholder="请输入图形验证码">
                <template #extra>
                    <img :src="imgUrl" @click="getCode" />
                </template>
            </van-field>
            <van-field
                v-model="form.checkCode"
                :maxlength="4"
                placeholder="请输入短信验证码"
            >
                <template #extra>
                    <span
                        class="sendBtn"
                        @click="sendMsg"
                        v-text="
                            (!state.smsSendBtn && '获取验证码') ||
                            state.time + ' s'
                        "
                        >发送验证码</span
                    >
                </template>
            </van-field>
            <van-button class="register-btn" @click="handleRegis"
                >立即注册</van-button
            >
        </div>
    </div>
</template>
<script>
import {
    fetchCode,
    fetchLogin,
    getSmsCaptcha,
    checkPhone,
} from "../services/common";
import { Notify } from "vant";

export default {
    data() {
        return {
            form: {
                username: "",
                checkCode: "",
                invitationCode: "",
                type: 0,
                registerActivityId: "",
            },
            code: "",
            imgUrl: "",
            state: {
                time: 60,
                smsSendBtn: false,
            },
        };
    },
    mounted() {
        const data = this.$route.query;
        this.form.invitationCode = data.code;
        if (data.activityId) {
            this.form.registerActivityId = data.activityId;
        }
        this.getCode();
    },
    methods: {
        handleRegis() {
            if (this.form.username === "") {
                Notify({ type: "warning", message: "请输入手机号" });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.username)) {
                Notify({ type: "warning", message: "请输入正确的手机号" });
                return false;
            }
            if (this.code === "") {
                Notify({ type: "warning", message: "请输入图形验证码" });
                return;
            }
            if (this.form.checkCode === "") {
                Notify({ type: "warning", message: "请输入短信验证码" });
                return;
            }
            fetchLogin(this.form).then((res) => {
                this.$router.push("/inviteSuccess");
            });
        },
        getCode() {
            return fetchCode()
                .then((res) => {
                    console.log(res.data);
                    return (
                        "data:image/gif;base64," +
                        btoa(
                            new Uint8Array(res.data).reduce(
                                (data, byte) =>
                                    data + String.fromCharCode(byte),
                                ""
                            )
                        )
                    );
                })
                .then((data) => {
                    this.imgUrl = data;
                    return data;
                });
        },
        sendMsg() {
            if (this.form.username === "") {
                Notify({ type: "warning", message: "请输入手机号" });
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.form.username)) {
                Notify({ type: "warning", message: "请输入正确的手机号" });
                return false;
            }
            if (this.code === "") {
                Notify({ type: "warning", message: "请输入图形验证码" });
                return;
            }
            if (this.code.length !== 4) {
                Notify({ type: "warning", message: "图形验证码长度需为4位" });
                return;
            }
            checkPhone({ phone: this.form.username }).then((res) => {
                console.log(res);
                if (res.existFlag.value === 1) {
                    Notify({
                        type: "warning",
                        message: "您已注册，请进入wowotown App体验美好生活",
                    });
                } else {
                    getSmsCaptcha({
                        phone: this.form.username,
                        businessType: "app_user_login",
                        checkCode: this.code,
                    })
                        .then((res) => {
                            Notify({
                                type: "success",
                                message: "验证码已发送，请查看",
                            });
                            this.state.smsSendBtn = true;
                            const interval = window.setInterval(() => {
                                if (this.state.time-- <= 0) {
                                    this.state.time = 60;
                                    this.state.smsSendBtn = false;
                                    window.clearInterval(interval);
                                }
                            }, 1000);
                        })
                        .catch(() => {
                            this.getCode();
                            // this.picCode = ''
                        });
                }
            });
            //
        },
    },
};
</script>

<style lang="less" scoped>
.button-wrapper {
    display: flex;
    padding: 0 15px;
    justify-content: space-between;
    .van-button {
        height: 40px;
        font-size: 22px;
        letter-spacing: 1px;
        padding: 0;
        width: 166px;
        &.face-invite {
            color: #f93b36;
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(254, 108, 96, 1);
            //border-image: linear-gradient(180deg, rgba(254, 108, 96, 1), rgba(247, 41, 35, 1)) 1 1;
        }
        &.instance-invite {
            background: linear-gradient(180deg, #ff6864 0%, #f82923 100%);
            color: white;
            border-color: #ff6864;
        }
    }
}
.inviteregis-container {
    width: 375px;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    background: url(../assets/regis.png) top left/100% 100% no-repeat;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
    height: 100%;
    background-size: 100%;
    .form-container {
        padding: 0 15px;
        margin-top: 130%;
        .register-btn {
            width: 100%;
            background: linear-gradient(180deg, #ff6763 0%, #f82a24 100%);
            border-radius: 8px;
            border: none;
            color: #fff;
            font-size: 16px;
        }
        .van-field {
            padding-top: 0;
            padding-bottom: 0;
            border-radius: 8px;
            margin-bottom: 10px;
            line-height: 42px;
            img {
                height: 42px;
            }
        }
    }
}
</style>
